import {
    Configuration,
    ConfigurationParameters,
    LocationPaymentMethodControllerApi,
    PaymentControllerApi,
    PaymentFeeControllerApi,
    PaymentMethodControllerApi,
    PaymentOperationsControllerApi,
} from '../generated-api'
import config from './config'

const configParams: ConfigurationParameters = {
    basePath: config.basePath,
    middleware: [],
}

const apiConfig = new Configuration(configParams)

export const apiClient = {
    PaymentMethodControllerApi: new PaymentMethodControllerApi(apiConfig),
    PaymentControllerApi: new PaymentControllerApi(apiConfig),
    PaymentOperationsOverviewApi: new PaymentOperationsControllerApi(apiConfig),
    LocationPaymentMethodControllerApi: new LocationPaymentMethodControllerApi(apiConfig),
    PaymentFeeControllerApi: new PaymentFeeControllerApi(apiConfig),
}

export type ApiClient = typeof apiClient
